import {
  Button,
  chakra,
  Grid,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { getEmptyRow } from "./ConsumptionsModalGridItemsSection";
import { NUMBER_OF_STATIC_COLS } from "./ConsumptionsGrid";
import { ConsumptionsGridHeaderRow, ConsumptionsModalGridItemsSection } from "./index";
import { SCOPES } from "../../helpers";

function ConsumptionsModal({ modalData, isOpen, onClose, onSubmit, scope }) {
  const { t } = useTranslation("translation");
  const { fieldArrayName, editData, columnNames } = modalData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    resetField,
    control,
    watch
  } = useForm({
    defaultValues: {
      [fieldArrayName]: [editData ? editData : getEmptyRow(scope)]
    }
  });

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <chakra.form onSubmit={handleSubmit(onSubmit)}>
          <ModalHeader>
            {t(`organizationQuestionnaire.${editData ? "editItemModalHeader" : "addItemsModalHeader"}`, { type: fieldArrayName })}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Grid
              templateColumns={`repeat(${(NUMBER_OF_STATIC_COLS + (scope === SCOPES.SCOPE_TWO ? 1 : 0)) * 2 + (editData ? 0 : 1)}, 1fr)`}
              minWidth="700"
              maxHeight="400"
              overflow="auto"
            >
              <ConsumptionsGridHeaderRow
                columnNames={columnNames}
              />
              <ConsumptionsModalGridItemsSection
                modalData={modalData}
                formData={{
                  control,
                  watch,
                  register,
                  errors,
                  resetField
                }}
              />
            </Grid>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onClose}>
              {t("buttons.close")}
            </Button>
            <Button colorScheme="customScheme" type="submit">
              {t("buttons.save")}
            </Button>
          </ModalFooter>
        </chakra.form>
      </ModalContent>
    </Modal>
  );
}

export default ConsumptionsModal;